import React from 'react';
import { useSearchParams } from 'react-router-dom';

import AlertStatic from '@buyside/components/presentation/AlertStatic/alertStatic';
import IndexPaginationNav from '@buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import MembersIndexCard from '@buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCard';
import MembersIndexCardLoading from '@buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCardLoading';

import { validatePageParam } from '@buyside/util/numbers';

import { usePublicUserFollowersQuery } from '@interfaces/graphql-typings';

const PublicUserFollowers: React.FC<{
  activeFollowersCount: number;
  canViewUserDetails: boolean;
  safeFirstName: string;
  userId: string;
}> = ({ activeFollowersCount, canViewUserDetails, safeFirstName, userId }) => {
  const [searchParams] = useSearchParams();
  const page = validatePageParam(searchParams);

  const { data, error, loading } = usePublicUserFollowersQuery({
    variables: { userId, page },
    skip: !activeFollowersCount
  });

  if (error) throw error;

  if (!activeFollowersCount)
    return <AlertStatic>{safeFirstName} does not have any followers.</AlertStatic>;

  const { followersList } = data?.userLookUp || {};

  return (
    <>
      {loading
        ? [...Array(3)].map((_, idx) => (
            <MembersIndexCardLoading key={`follower-skeleton-${idx}`} />
          ))
        : null}
      {followersList?.edges?.map(edge =>
        edge?.node ? (
          <MembersIndexCard
            key={`follower-${edge.node.id}`}
            canViewUserDetails={canViewUserDetails}
            node={edge.node}
          />
        ) : null
      )}
      <IndexPaginationNav
        loading={loading}
        resultCount={activeFollowersCount}
        resultLength={followersList?.edges?.length || 0}
        resultsPerPage={20}
      />
    </>
  );
};

export default PublicUserFollowers;
